import {BrowserRouter, Routes, Route} from 'react-router-dom';
import {AnimatePresence} from 'framer-motion';
import './App.css';
import 'remixicon/fonts/remixicon.css';
import {Provider} from 'react-redux';
import store from './redux/store';
import Admin from './pages';
import AdminLogin from './pages/login';
import ForgotPassword from './pages/forgot';
import 'bootstrap/dist/css/bootstrap.min.css';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css'
import VerifyToken from './pages/verify-token';
import ResetPassword from './pages/reset-password';

function App() {
    return (
        <Provider store={store}>
            <ToastContainer theme='colored'/>
            <div className="App">
                <AnimatePresence exitBeforeEnter>
                    <BrowserRouter>
                        <Routes>
                            <Route path="/" element={< Admin />}/>
                            <Route path="login" element={< AdminLogin />}/>
                            <Route path="forgot" element={< ForgotPassword/>}/>
                            <Route path="verify-token" element={< VerifyToken/>}/>
                            <Route path="reset-password" element={< ResetPassword/>}/>
                        </Routes>
                    </BrowserRouter>
                </AnimatePresence>
            </div>
        </Provider>
    );
}

export default App;
